const DEFAULT_PARAMETERS = {
  category: 3
}

export const getFilterSearchParameters = () => {
  const url = new URL(location.href)
  const params = url.searchParams

  const theme = params.get('theme')
  const region = params.get('region')
  const category = params.get('category') ?? DEFAULT_PARAMETERS.category
  const min = params.get('min')
  const max = params.get('max')

  const filterParams = Object.fromEntries(
    Object.entries({
      theme,
      region,
      category,
      min,
      max
    }).filter(([_, v]) => v != null)
  ) as Record<string, string>

  return filterParams
}
